import axios from "axios";
import { getAxiosConfig } from "./api-config";
import { combineSectionIds } from "./combineSectionIds";
import { toastSuppressedForUrl } from "./toastSuppressedForUrl";

const CONTENT_API_BASE_URL = "/api/content";
const CONTENT_API_BASE_URL_V2 = "/api/content/v2";

export class ApiService {
  constructor() {
    const axiosConfig = getAxiosConfig();
    this.requests = axios.create(axiosConfig);
  }

  initErrorHandling = (callback) => {
    return this.requests.interceptors.response.use(undefined, (res) => {
      if (!toastSuppressedForUrl(res.config.url)) {
        callback();
      }
    });
  };

  async get(path, queryConfig = {}) {
    return this.requests.get(path, queryConfig);
  }

  async post(path, body) {
    return this.requests.post(path, body);
  }

  async getContent(slugPubType, slugTitle, tabType, sectionIds, pathSectionId) {
    let slugUrl = `/${slugPubType}/${slugTitle}`;
    if (tabType) {
      slugUrl += `/${tabType}`;
    }
    if (pathSectionId) {
      slugUrl += `/${pathSectionId}`;
    }

    let params = {};
    if (sectionIds) {
      const idString = combineSectionIds(sectionIds);

      params = {
        ids: idString,
        ...params,
      };
    }

    const { data } = await this.requests.get(
      CONTENT_API_BASE_URL_V2 + slugUrl,
      { params }
    );

    return data;
  }

  async getSection(slugPubType, slugTitle, sectionId) {
    const slugUrl = `/sections/${slugPubType}/${slugTitle}`;

    const params = {
      ids: sectionId,
    };

    const { data } = await this.requests.get(
      CONTENT_API_BASE_URL_V2 + slugUrl,
      { params }
    );
    return data;
  }

  async getDetailsSection(slugPubType, slugTitle, sectionId) {
    let slugUrl = `/${slugPubType}/${slugTitle}/details`;

    if (sectionId) {
      slugUrl += `/${sectionId}`;
    }

    const { data } = await this.requests.get(CONTENT_API_BASE_URL_V2 + slugUrl);
    return data;
  }

  async getSelectedDetailsSections(slugPubType, slugTitle, sectionIdsToQuery) {
    const slugUrl = `/drugdetails/${slugPubType}/${slugTitle}`;

    let params;
    if (sectionIdsToQuery) {
      params = { sectionIds: sectionIdsToQuery.join() };
    }

    const { data } = await this.requests.get(
      CONTENT_API_BASE_URL_V2 + slugUrl,
      { params }
    );
    return data;
  }

  async putBookmark(slugPubType, slugTitle) {
    const slugUrl = `/bookmarks/${slugPubType}/${slugTitle}`;
    const { data } = await this.requests.put(CONTENT_API_BASE_URL + slugUrl);
    return data;
  }

  async deleteBookmark(slugPubType, slugTitle) {
    const slugUrl = `/bookmarks/${slugPubType}/${slugTitle}`;
    const { data } = await this.requests.delete(CONTENT_API_BASE_URL + slugUrl);
    return data;
  }

  async putContentSubscription(slugPubType, slugTitle, subscriptionType = {}) {
    const slugUrl = `/subscriptions/${slugPubType}/${slugTitle}`;
    const { data } = await this.requests.put(CONTENT_API_BASE_URL + slugUrl, {
      subscriptionType,
    });
    return data;
  }

  async deleteContentSubscription(slugPubType, slugTitle) {
    const slugUrl = `/subscriptions/${slugPubType}/${slugTitle}`;
    const { data } = await this.requests.delete(CONTENT_API_BASE_URL + slugUrl);
    return data;
  }

  async getCloudinaryToken() {
    const { data } = await this.requests({
      url: "/cloudinary-token",
      baseURL: "",
    });

    return data;
  }

  async getMerativeLinkWithToken(baseUrl) {
    const apiPath = `/merative-links`;

    const params = { baseUrl };

    const { data } = await this.requests.get(CONTENT_API_BASE_URL + apiPath, {
      params,
    });
    return data;
  }

  async getShareDetailsData() {
    const { data } = await this.requests({
      url: "/session/share-details",
      baseURL: "",
    });

    return data;
  }

  async fetchPercRedirectLink({ an, db }) {
    try {
      const path = `/perc-link?db=${db}&an=${an}`;
      const { data } = await this.requests.get(CONTENT_API_BASE_URL + path);

      return data.url;
    } catch {
      return null;
    }
  }
}

const apiService = new ApiService();
export default apiService;
